<template>
  <v-alert type="success" v-model="alerMessage.show" class="my-8">
    {{ rewriteMessage(alerMessage.message) }}
  </v-alert>
</template>

<script>
  export default {
    name: 'alert-message-success',
    props: ['alerMessage'],
    data: () => ({
    }),
    computed: {
    },
    methods: {
      rewriteMessage(msg) {
        msg = msg.replace(this.alerMessage.omitMessage, '')
        return msg.charAt(0).toUpperCase() + msg.slice(1)
      }
    },
    mounted() {
    },
    components: {
    }
  }
</script>
